import PropTypes from "prop-types";
import { useImperativeHandle, useState } from "react";

import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import AssignHoldMessageForm from "./AssignHoldMessageForm";

const AssignHoldMessageModal = ({ onSuccess, ref }) => {
  const [open, setOpen] = useState(false);
  const [twilioPhoneNumberId, setTwilioPhoneNumberId] = useState();
  const [holdMessage, setHoldMessage] = useState();

  useImperativeHandle(ref, () => ({
    open: (nextTwilioPhoneNumberId, nextHoldMessage) => {
      setTwilioPhoneNumberId(nextTwilioPhoneNumberId);
      setHoldMessage(nextHoldMessage);
      setOpen(true);
    },
  }));

  const handleSuccess = () => {
    setOpen(false);
    onSuccess?.();
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent>
        <DialogTitle>Set Hold Message</DialogTitle>
        {open && twilioPhoneNumberId != null && (
          <AssignHoldMessageForm
            twilioPhoneNumberId={twilioPhoneNumberId}
            holdMessage={holdMessage}
            onSuccess={handleSuccess}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};

AssignHoldMessageModal.propTypes = {
  onSuccess: PropTypes.func.isRequired,
  ref: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default AssignHoldMessageModal;
